import { render } from "./HowToTalk.vue?vue&type=template&id=05a68d23&scoped=true"
import script from "./HowToTalk.vue?vue&type=script&lang=js"
export * from "./HowToTalk.vue?vue&type=script&lang=js"

import "./HowToTalk.vue?vue&type=style&index=0&id=05a68d23&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a68d23"]])

export default __exports__